export default __webpack_public_path__ + "static/media/info-icon-v2.2c6e11f5.svg";